import https from "./https";
import store from "@/store"

const organization = store.state.general.organization;

const hty = {
  query(params) {
    return https.get(
      `admin/organizations/${organization.id}/hty/query`, 
      { params }
    );
  },

  verifyPhone(params) {
    return https.post(
      `admin/organizations/${organization.id}/hty/verify-phone`, 
      params
    );
  },

  createAccount(params) {
    return https.post(
      `admin/organizations/${organization.id}/hty/create-account`, 
      params
    );
  },

  modifyAccount(params) {
    return https.post(
      `admin/organizations/${organization.id}/hty/modify-account`, 
      params
    );
  },

  modifyLine(params) {
    return https.post(
      `admin/organizations/${organization.id}/hty/modify-line`, 
      params
    );
  },

  deleteAccount(params) {
    return https.post(
      `admin/organizations/${organization.id}/hty/delete-account`, 
      params
    );
  }
};

export default hty
